import JSX from "../../helpers/react.js";
import RefObject = JSX.RefObject;

export function TrailerButton({url, onClick, title, ref}: {url: string, onClick: (url: string) => any, title: string, ref: RefObject}){
    return (
        <div data-id={title} className="materiable bordered-overflow video-button" onClick={()=>onClick(url)} ref={ref}>{title}</div>
    )
}